export type LatLng = [number, number];

export function openGoogleMapsRoute(coords: LatLng[]) {
    if (coords.length === 0) {
        console.error("At least one coordinate is required.");
        return;
    }

    const baseUrl = "https://www.google.com/maps";

    if (coords.length === 1) {
        const location = encodeURIComponent(coords[0].join(","));
        const url = `${baseUrl}/search/?api=1&query=${location}`;
        window.open(url, "_blank");
    } else {
        const origin = encodeURIComponent(coords[0].join(","));
        const destination = encodeURIComponent(coords[coords.length - 1].join(","));

        const waypoints = coords
            .slice(1, -1)
            .map((coord) => encodeURIComponent(coord.join(",")))
            .join("|");

        const url =
            `${baseUrl}/dir/?api=1` +
            `&origin=${origin}` +
            `&destination=${destination}` +
            `&travelmode=driving` +
            (waypoints ? `&waypoints=${waypoints}` : "");

        window.open(url, "_blank");
    }
}
